module.exports = __webpack_public_path__ + "static/obvious_checkout_1-1f130d605617e2c1220b942ed86266bf.jpg";